export const keysNumbers = {
  list: [
    {
      type: '1',
      line: [
        {
          letter: '1',
        },
        {
          letter: '2',
        },
        {
          letter: '3',
        },
      ],
    },
    {
      type: '2',
      line: [
        {
          letter: '4',
        },
        {
          letter: '5',
        },
        {
          letter: '6',
        },
      ],
    },
    {
      type: '3',
      line: [
        {
          letter: '7',
        },
        {
          letter: '8',
        },
        {
          letter: '9',
        },
      ],
    },
    {
      type: '4',
      line: [
        {
          letter: '0',
        },
        {
          type: 'bksp',
          className: 'keyboard__button_bksp',
        },
      ],
    },
  ],
};
